import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DTE_TYPE_LABELS, STATUS_LABELS } from "../types";
import type { DteTypeCode, TaxDocumentStatus } from "../types";

interface TaxDocumentFiltersProps {
  filters: {
    search?: string;
    status?: string;
    documentType?: string;
    fromDate?: string;
    toDate?: string;
  };
  onFilterChange: (key: string, value: string) => void;
}

export function TaxDocumentFilters({
  filters,
  onFilterChange,
}: TaxDocumentFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4 mb-6">
      {/* Search */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar por folio o cliente..."
          value={filters.search ?? ""}
          onChange={(e) => onFilterChange("search", e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Document Type */}
      <Select
        value={filters.documentType ?? "all"}
        onValueChange={(value) =>
          onFilterChange("documentType", value === "all" ? "" : value)
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Tipo documento" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          {(Object.entries(DTE_TYPE_LABELS) as [string, string][]).map(
            ([code, label]) => (
              <SelectItem key={code} value={code}>
                {label}
              </SelectItem>
            )
          )}
        </SelectContent>
      </Select>

      {/* Status */}
      <Select
        value={filters.status ?? "all"}
        onValueChange={(value) =>
          onFilterChange("status", value === "all" ? "" : value)
        }
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          {(Object.entries(STATUS_LABELS) as [TaxDocumentStatus, string][]).map(
            ([status, label]) => (
              <SelectItem key={status} value={status}>
                {label}
              </SelectItem>
            )
          )}
        </SelectContent>
      </Select>

      {/* Date Range */}
      <div className="flex items-center gap-2">
        <Input
          type="date"
          value={filters.fromDate ?? ""}
          onChange={(e) => onFilterChange("fromDate", e.target.value)}
          className="w-[150px]"
        />
        <span className="text-muted-foreground">-</span>
        <Input
          type="date"
          value={filters.toDate ?? ""}
          onChange={(e) => onFilterChange("toDate", e.target.value)}
          className="w-[150px]"
        />
      </div>
    </div>
  );
}
